import React, { useState, useEffect } from 'react';
import { Table, Button } from 'react-bootstrap';
import './formato.css';
import { ErrorModal } from 'components';
import { useHistory } from 'react-router-dom';
import deleteIcon from 'assets/img/deleteIcon_black.png';
import deleteIconWhite from 'assets/img/trashWhite.svg';
import { infotabla, deleteInvitados } from 'services/rsvp/getRSVP';
import { hideLoader, showLoader } from 'store/actions/commons';
import { useStore } from 'store';
import styles from './styles.module.scss';
import { useWindowSize } from 'hooks';

const MyTableGuestsCompanion = ({ typeId }) => {
  const { isMobile } = useWindowSize({ largeMobile: true })[1];
  const history = useHistory();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [guestId, setGuestId] = useState('');
  const [servicioGuest, setServicioGuest] = useState([]);
  const [, dispatch] = useStore((state) => state.giftTable.giftTable);
  const [loaders, setLoaders] = useState(false);
  const [deleteGuest, setDeleteGuest] = useState(false);

  const handleClose = () => {
    setShowErrorModal(false);
  };

  const handleClickDelete = (guestId) => {
    setShowErrorModal(true);
    setGuestId(guestId);
  };

  const handleClickDeleteConfirm = () => {
    deleteInvitados(guestId).then((valorDeServicio) => {
      console.log('deleteInvitados en confirma tus invitados   ', valorDeServicio);
      console.log('servicioDeleteInvitados en confirma tus invitados ', valorDeServicio);
      if (valorDeServicio?.data?.success == true) {
        console.log('LLamar servicio para volver a cargar la data')
        setDeleteGuest(!deleteGuest);
      } else {
        alert('Error al eliminar invitado');
      }
    });
    console.log('LLamar servicio eliminar guestID ', guestId);
    setShowErrorModal(false);
  };

  const handleClickAdd = (guestId) => {
    history.push('/agrega-acompanante/' + guestId);
  };

  useEffect(() => {
    dispatch(showLoader());
    console.log('typeId', typeId);
    infotabla(typeId).then((valorDeServicio) => {
      console.log('infotabla hay invitacion ', valorDeServicio);
      if (valorDeServicio == false) {
        console.log('No hay invitados en la mesa');
      } else {
        console.log('infotabla en confirma invitados ', valorDeServicio?.data?.items);
        setServicioGuest(valorDeServicio?.data?.items);
        setLoaders(!loaders);
      }
    });
  }, [typeId, deleteGuest]);

  useEffect(() => {
    dispatch(hideLoader());
  }, [loaders]);

  return (
    <div className="row">
      <div className={`${styles.tableresp} table-responsive border`}>

        {!isMobile ? (
          <div className={`${styles.tableresp} table-responsive border `} style={{ overflowY: 'auto', maxHeight: '500px' }}>
            <Table striped>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>Nombre</th>
                  <th colSpan={2} style={{ textAlign: 'left' }}>&nbsp;&nbsp;&nbsp;Acompañantes</th>
                  <th colSpan={2} style={{ textAlign: 'left' }}>Email</th>
                </tr>
              </thead>
              <tbody>
                {servicioGuest.map((item) => (
                  <tr key={item.gift_table_guest_id}>
                    <td className="align-middle" style={{ textAlign: 'left' }}>{item.name}</td>
                    <td colSpan={2} className="text-center align-middle" style={{ textAlign: 'left' }}>
                      {item.asistentes}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <Button className='btn btn-sm' variant="secundary" style={{ color: 'red',fontSize:'smaller' }} onClick={() => handleClickAdd(item.gift_table_guest_id)}>
                      <i class="fa fa-user-plus fa-lg" aria-hidden="true" style={{ color: 'red' }}></i>&nbsp; Agregar acompañante
                      </Button>
                    </td>
                    <td className="align-middle" style={{ textAlign: 'left' }}>{item.email}</td>
                    <td className="align-middle" style={{ textAlign: 'left' }}>
                      <img src={deleteIcon} alt="Eliminar invitado" onClick={() => handleClickDelete(item.gift_table_guest_id)} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ):(
          <Table >
            <thead>
              <tr>
                <th>Lista de invitados&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {servicioGuest.map((item) => (
                <tr key={item.gift_table_guest_id}>
                  <td>
                    <div className="d-flex">
                      <div className={styles.leftContent} >
                        <b className="card-title"><strong>{item.name}</strong></b>
                        <p className={styles.spanText}>
                          { item.status != 'no asistira' &&  (item.asistentes > 1 ? item.asistentes + ' acompañantes' : item.asistentes + ' acompañante')}
                        </p>
                        <p className={styles.spanText}>{item.email}</p>
                      </div>
                      <div className={styles.rightContent} >
                        <img style={{height:'35px'}}  src={deleteIconWhite} alt="Eliminar invitado" onClick={() => handleClickDelete(item.gift_table_guest_id)} />
                        <br/>
                        <a style={{ cursor: 'pointer' }} className={styles.blueLink} onClick={() => handleClickAdd(item.gift_table_guest_id)}>Agregar acompañante</a>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )
        }

      </div>
      <ErrorModal
        show={showErrorModal}
        title=""
        titleHeader=""
        titleHeaderClassName="col-md-12 offset-md-3"
        actionLabel="Eliminar"
        onAction={handleClickDeleteConfirm}
        onClose={handleClose}
        closeLabel='Eliminar'
        type={''}
        subtitle={
          <p className="text-center">
            <b>Eliminar invitado</b><br /><br />
            ¿Estás seguro que deseas<br />
            eliminar a tu invitado y la<br />
            información de sus<br />
            acompañantes?<br />
          </p>
        }
      />
    </div>
  );
};

export default MyTableGuestsCompanion;
